import { Box, Stack } from "@mui/system";
import ButtonElement from "../../UI/ButtonElement/ButtonElement";
import { TablePagination } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./BillsPagination.scss";
import { ROWS_PER_PAGE_OPTIONS } from "../../../core/constants/constants";
import { SelectedRows } from "../../../core/models/bills/bills.model";

interface BillsPaginationProps {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  rowsPerPage: number;
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>;
  selectedRows: SelectedRows[];
  totalRegistersQuery: number;
  isDesktopViewport: boolean;
  isTableLoading: boolean;
  setIsDownloadDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsSelectedDownloader: React.Dispatch<React.SetStateAction<boolean>>;
}

const BillsPagination = ({
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  selectedRows,
  isTableLoading,
  setIsDownloadDrawerOpen,
  setIsSelectedDownloader,
  totalRegistersQuery,
  isDesktopViewport,
}: BillsPaginationProps) => {
  const { t } = useTranslation();

  const showPagination =
    !isTableLoading &&
    Math.ceil(totalRegistersQuery / rowsPerPage) !== 1 &&
    totalRegistersQuery >= rowsPerPage;

  return (
    <Box component="article" className="bills-pagination">
      {isDesktopViewport && (
        <Stack direction={"row"} gap={"1.5rem"} component="div">
          {!!selectedRows.length && (
            <ButtonElement
              iconL
              onClick={() => {
                setIsDownloadDrawerOpen(true);
                setIsSelectedDownloader(true);
              }}
              iconName="t-icon-download"
            >
              {t("Facturas Página.Descargar selección")}{" "}
              {`(${selectedRows.length})`}
            </ButtonElement>
          )}
          <ButtonElement
            secondary
            iconL
            onClick={() => setIsDownloadDrawerOpen(true)}
            iconName="t-icon-download"
          >
            {t("Facturas Página.Descargar todas")} {`(${totalRegistersQuery})`}
          </ButtonElement>
        </Stack>
      )}
      {showPagination && (
        <TablePagination
          className="table-pagination"
          showFirstButton
          showLastButton
          component="div"
          rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
          labelRowsPerPage={t(`Tablas.Filas por página`)}
          labelDisplayedRows={({ page, count }) =>
            t("Tablas.Página de", {
              actual: page + 1,
              total: Math.ceil(count / rowsPerPage),
            })
          }
          count={totalRegistersQuery}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(
            event: React.MouseEvent<HTMLButtonElement> | null,
            newPage: number
          ) => {
            setPage(newPage);
          }}
          onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
          }}
        />
      )}
    </Box>
  );
};

export default BillsPagination;
